import startCase from 'lodash/startCase'
export default function format (entity, item, type = 'table') {
    switch (entity) {

        case 'treatment':
            return item && item.drug

        // special case to transform field name into label (mainly used for audit trail foreigns)
        case 'field_name':
            if (item === 'n_pieces') {
                return 'Quantity'
            }
            return startCase(item && item.replace('_', ' ').replace(/ id$/, ''))
        case 'field_value':
            return item
        default:
            return (item && item.name || item)
            // console.error('entity ', entity)
            // console.error(item)
            // return item
            // return item && item.name || 
    }
}